import {
  faBell,
  faBullseyeArrow,
  faCog,
  faDroplet,
  faMoonStars,
  faSpa,
  faTrashCan,
  faWavePulse,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { colours } from '../../../assets/colours';
import ReminderPopUp from '../../../contentTypes/components/ReminderPopUp';
import ChevronBackBtn from '../../../shared/components/styledComponents/chevronBackBtn/ChevronBackBtn';
import ToggleBtn from '../../../shared/components/styledComponents/toggleBtn/ToggleBtn';
import { GreenCheckOverlay } from '../../../shared/modal/greenCheckOverlay/GreenCheckOverlay';

type RemindersRightMenuProps = {
  hide: boolean;
  changeMenu: (arg0: number, arg1: string) => void;
  showGreenCheck?: boolean;
};

export function RemindersRightMenu({
  hide,
  changeMenu,
  showGreenCheck = false,
}: RemindersRightMenuProps) {
  const { t } = useTranslation();
  const [remindersOn, setRemindersOn] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentReminder, setCurrentReminder] = useState(null);

  const [remindersArr, setRemindersArr] = useState([
    { id: 1, title: t('T338'), icon: faBell, position: true },
    {
      id: 2,
      title: 'Goals',
      icon: faBullseyeArrow,
      position: true,
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 3,
      title: 'Meditate',
      icon: faSpa,
      position: true,
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 4,
      title: 'Get Moving',
      icon: faWavePulse,
      position: true,
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 5,
      title: 'Drink Water',
      icon: faDroplet,
      position: true,
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 6,
      title: 'Sleep Routine',
      icon: faMoonStars,
      position: true,
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
  ]);

  const [contentReminders, setContentReminders] = useState([
    {
      id: 1,
      title: 'Exercise & Asthma',
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 2,
      title: 'Supporting your Partner through the Menopause',
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
    {
      id: 3,
      title: 'The Stream',
      time: '10:00',
      days: 'Mon, Wed, Fri',
      repeat: false,
    },
  ]);
  const handleReminderToggle = (id) => {
    if (id === 1) {
      setRemindersOn(!remindersOn);
    }
    const updatedReminders = remindersArr.map((reminder) => {
      if (reminder.id !== id) {
        return reminder;
      }
      if (reminder.position) {
        return { ...reminder, position: false };
      }
      const updatedReminder = { ...reminder, position: true };
      setModalIsOpen(true);
      setCurrentReminder(updatedReminder);
      return updatedReminder;
    });
    setRemindersArr(updatedReminders);
  };

  const modalClickHandler = useCallback(() => {
    setModalIsOpen(false);
  }, [modalIsOpen]);

  const editContentReminder = (id) => {
    setCurrentReminder(() => contentReminders.find((reminder) => reminder.id === id));
    setModalIsOpen(true);
  };
  const deleteContentReminder = (id) => {
    setContentReminders((prevReminders) => prevReminders.filter((reminder) => reminder.id !== id));
  };

  return (
    <>
      {modalIsOpen && (
        <ReminderPopUp
          currentItem={currentReminder}
          notifications
          setRemindOpen={modalClickHandler}
        />
      )}
      {showGreenCheck && <GreenCheckOverlay text={t('saved_changes_successfully')} />}

      <div className="edit-field reminders fs-exclude">
        {hide && (
          <div className="btn-cont ">
            <ChevronBackBtn onClick={() => changeMenu(0, 'back')} />
          </div>
        )}
        <div className="edit-title">{t('T338')}</div>
        <div className="scrollable">
          {remindersArr.map((reminder, index) => {
            return (
              <div
                className="profile-slider-btn reminders"
                key={index}
                style={
                  index === 0
                    ? {
                        background: 'rgba(100, 89, 107, 0.5)',
                        border: 'solid 1px rgba(100, 89, 107, 0.2)',
                        marginBottom: '20px',
                      }
                    : {}
                }
              >
                <div className="menu-item">
                  <FontAwesomeIcon
                    icon={reminder.icon}
                    style={{ color: colours.green }}
                    className="slider-icon"
                  />
                  <div className="slider-text">{reminder.title}</div>
                </div>
                <ToggleBtn
                  isOn={remindersOn ? reminder.position : false}
                  onToggle={() => handleReminderToggle(reminder.id)}
                  containerColor={reminder.position && remindersOn ? colours.green : '#64596b'}
                  toggleColor="#fff"
                  size={{ width: '62px', height: '35px' }}
                />
              </div>
            );
          })}
          {contentReminders.map((reminder, index) => {
            return (
              <div className="profile-slider-btn reminders content" key={index * reminder.id}>
                <div className="circle" />
                <div className="content-remind">
                  <span>Reminder for</span>
                  <div className="slider-text">{reminder.title}</div>
                </div>

                <FontAwesomeIcon
                  icon={faCog}
                  className="icon"
                  onClick={() => editContentReminder(reminder.id)}
                />

                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon"
                  style={{ color: `${colours.red}` }}
                  onClick={() => deleteContentReminder(reminder.id)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
